import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { InventoryGroupConfigComponent } from './inventory-group-config/inventory-group-config.component';
import { InventoryIbnComponent } from './inventory-ibn/inventory-ibn.component';
import { InventoryItemComponent } from './inventory-item/inventory-item.component';
import { InventoryExpendedSearchComponent } from './inventory-expended-search/inventory-expended-search.component';
import { InventoryComponent } from './inventory/inventory.component';
import { ViewInventoryComponent } from './view-inventory/view-inventory.component';
import { ViewTravelersComponent } from './view-travelers/view-travelers.component';
import { TravelerComponent } from './traveler/traveler.component';
import { TravelerConfigComponent } from './travelerConfig/travelerConfig.component';
import { CanDeactivateGuard } from 'src/app/guards/can-deactivate-guard.service';
import { ManuallyExpendedComponent } from './manually-expended/manually-expended.component';
import { InventoryReceivedSearchComponent } from './inventory-received-search/inventory-received-search.component';
import { ImportInventoryComponent } from './import-inventory/import-inventory.component';

const inventoryRoutes: Routes = [
    {
        path: "",
        component: InventoryComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                children: [
                    { path: './', redirectTo: "", pathMatch: "full" },
                    { path: '', component: ViewInventoryComponent },
                    { path: 'viewInventory', component: ViewInventoryComponent },
                    { path: 'inventoryItem', component: InventoryItemComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'inventoryItemCreate', component: InventoryItemComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'inventoryItem/:id', component: InventoryItemComponent, canDeactivate: [CanDeactivateGuard] },
                    { path: 'traveler', component: TravelerComponent },
                    { path: 'traveler/:wiId', component: TravelerComponent },
                    { path: 'viewTravelers', component: ViewTravelersComponent },
                    { path: 'inventoryIbns', component: InventoryIbnComponent },
                    { path: 'config', component: InventoryGroupConfigComponent },
                    { path: 'travelerConfig', component: TravelerConfigComponent },
                    { path: 'expendedInventory', component: InventoryExpendedSearchComponent },
                    { path: 'receivedInventory', component: InventoryReceivedSearchComponent },
                    { path: 'manuallyExpended/:id', component: ManuallyExpendedComponent, },
                    { path: 'importInventory', component: ImportInventoryComponent }
                ]
            }
        ]
    },

];

@NgModule({
  imports: [RouterModule.forChild(inventoryRoutes)],
  exports: [RouterModule]
})
export class InventoryRoutingModule { }
